import { Flex } from '@chakra-ui/react';
import { CenterSpinner } from '../ats';
import { SearchBottomBar } from './SearchBottomBar';

export const SearchLoading = () => {
  return (
    <Flex flexDirection="column">
      <CenterSpinner h="500px" />
      <SearchBottomBar />
    </Flex>
  );
};
